import { BellRing, Pencil, Trash2, Zap, Play } from "lucide-react";

const DAYS = ["M", "T", "W", "T", "F", "S", "S"];

export function PushEnableCard({ subscribed, enabling, onEnable }) {
  if (subscribed) {
    return (
      <div className="text-xs text-emerald-800 font-semibold inline-flex items-center gap-1" data-testid="push-enabled-badge">
        <BellRing className="w-3.5 h-3.5" /> Notifications on for this device
      </div>
    );
  }
  return (
    <button data-testid="enable-push-btn" onClick={onEnable} disabled={enabling}
      className="w-full flex items-center gap-3 rounded-2xl p-3 bg-amber-50 border border-amber-200 text-left hover:border-amber-400 transition">
      <BellRing className="w-5 h-5 text-amber-700 shrink-0" />
      <div>
        <div className="text-sm font-semibold text-stone-900">{enabling ? "Asking your browser…" : "Turn on notifications"}</div>
        <div className="text-xs text-stone-600">Get reminders even when the app is closed. On iPhone, add the app to your Home Screen first.</div>
      </div>
    </button>
  );
}

export function PointsInfo() {
  return (
    <div className="rounded-2xl bg-stone-50 p-3 text-xs text-stone-600 flex items-start gap-2" data-testid="reminder-points-info">
      <Zap className="w-3.5 h-3.5 text-amber-600 mt-0.5 shrink-0" />
      <span>
        <strong className="text-stone-800">Points:</strong> check in before any reminder <strong>15</strong> · right after a reminder <strong>10</strong> · each snooze −2 (never below 4). Every check-in still counts.
      </span>
    </div>
  );
}

function DayDots({ days }) {
  return (
    <div className="flex items-center gap-1 mt-1">
      {DAYS.map((d, i) => (
        <span key={`${d}${i}`} className={`w-5 h-5 rounded-full text-[10px] font-bold flex items-center justify-center ${days.includes(i) ? "bg-stone-900 text-white" : "bg-stone-100 text-stone-400"}`}>{d}</span>
      ))}
    </div>
  );
}

function reminderMeta(r) {
  const esc = r.escalation.enabled ? `escalates (${r.escalation.pace})` : "no escalation";
  const snoozes = `${r.escalation.max_snoozes} snooze${r.escalation.max_snoozes === 1 ? "" : "s"}`;
  const channels = ["push", "in_app", "email"].filter((c) => r.channels[c]).map((c) => c.replace("_", "-")).join(" · ");
  return `${r.smart ? "Smart · " : ""}${esc} · ${snoozes}${channels ? ` · ${channels}` : ""}`;
}

export function ReminderItem({ r, onToggle, onTest, onEdit, onRemove }) {
  return (
    <li data-testid={`reminder-item-${r.id}`} className={`rounded-2xl border p-3 ${r.active ? "border-stone-200" : "border-stone-100 opacity-60"}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-mono text-lg font-bold text-stone-900">{r.time}</div>
          <div className="text-sm font-semibold text-stone-800">{r.habit_title}</div>
          <DayDots days={r.days} />
          <div className="text-[10px] text-stone-500 mt-1">{reminderMeta(r)}</div>
        </div>
        <div className="flex flex-col items-end gap-1">
          <button data-testid={`reminder-toggle-${r.id}`} onClick={() => onToggle(r)} className={`text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full ${r.active ? "bg-emerald-100 text-emerald-800" : "bg-stone-100 text-stone-500"}`}>
            {r.active ? "On" : "Off"}
          </button>
          <div className="flex gap-2 mt-1">
            <button data-testid={`reminder-test-${r.id}`} onClick={() => onTest(r)} title="Send a test" className="text-stone-400 hover:text-amber-700"><Play className="w-3.5 h-3.5" /></button>
            <button data-testid={`reminder-edit-${r.id}`} onClick={() => onEdit(r)} className="text-stone-400 hover:text-stone-800"><Pencil className="w-3.5 h-3.5" /></button>
            <button data-testid={`reminder-delete-${r.id}`} onClick={() => onRemove(r.id)} className="text-stone-400 hover:text-red-700"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      </div>
    </li>
  );
}

export function ReminderStats({ history }) {
  if (!history || !(history.fired > 0)) return null;
  return (
    <div className="text-[11px] text-stone-500 font-mono pt-2 border-t border-stone-100" data-testid="reminder-stats">
      {history.fired} fired · {history.done} led to a check-in · {history.snoozes} snoozes total
    </div>
  );
}
